<script lang="ts" setup>
import { storeToRefs } from "pinia";
import { usePipStore } from "@/store/pip.store";

const pipStore = usePipStore();
const { pipContainer, content } = storeToRefs(pipStore);
</script>

<template>
  <teleport v-if="pipContainer && content" :to="pipContainer">
    <v-defaults-provider :defaults="{ global: { attach: pipContainer } }">
      <component :is="content.component" v-bind="content.props" v-on="content.on ?? {}" />
    </v-defaults-provider>
  </teleport>
</template>

<style lang="scss">
.pip-layout {
  height: 100vh;
  overflow: hidden;
}
</style>
